import { render, staticRenderFns } from "./DailyBoxList.vue?vue&type=template&id=0ada98d2"
import script from "./DailyBoxList.vue?vue&type=script&lang=js"
export * from "./DailyBoxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports